<!--
/*******************************************************************************
*@ 컴포넌트명   : MainFnnclInfo.vue
*@ 컴포넌트설명 : 메인 - Finanial (영업점소개, 환율)
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="financial-cont" v-if="pageData == '2'">
    <article>
      <app-bar
        :transparent="$route.meta.transparent || false"
        :goback="$route.meta.goback || false"
        :nation="$route.meta.nation || false"
        :home="$route.meta.home || false"
      />
    </article>
    <article class="contents">
      <!-- Branch Info -->
      <div class="branch-info">
        <div class="cont-tit">
          <h6>{{ /*영업점 안내*/ $t("MMAIN-03-01-02-01") }}</h6>
        </div>
        <template v-if="siteCode == $config.SITECODE_OGHCM && !isLogin">
          <div class="box-normal">
            <div class="header">
              <div class="tit">{{ $t(`${operGroupCd}_지점명`) }}</div>
            </div>
            <div class="content">
              <div class="item">
                <div class="tit">{{ /*영업시간*/ $t("MMAIN-03-01-02-13") }}:</div>
                <div
                  class="dec"
                >{{ `${/*월*/ $t("MCOM-0000099")}~${/*금*/ $t("MCOM-0000103")}` }}, {{ $t(`영업시간_${siteCode}`) }}</div>
              </div>
              <div class="item">
                <div class="tit">{{ /*전화*/ $t("MMAIN-03-01-02-05") }}:</div>
                <div class="dec">{{ $t(`지점별전화번호_${siteCode}`) }}</div>
              </div>
            </div>
          </div>
          <div class="box-normal">
            <div class="header">
              <div class="tit">{{ /*하노이지점*/ $t("VN2_지점명") }}</div>
            </div>
            <div class="content">
              <div class="item">
                <div class="tit">{{ /*영업시간*/ $t("MMAIN-03-01-02-13") }}:</div>
                <div
                  class="dec"
                >{{ `${/*월*/ $t("MCOM-0000099")}~${/*금*/ $t("MCOM-0000103")}` }}, {{ $t(`영업시간_${siteCode}`) }}</div>
              </div>
              <div class="item">
                <div class="tit">{{ /*전화*/ $t("MMAIN-03-01-02-05") }}:</div>
                <div class="dec">{{ $t("지점별전화번호_oghni") }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="box-normal">
            <div class="header">
              <div class="tit">{{ $t(`${operGroupCd}_지점명`) }}</div>
            </div>
            <div class="content">
              <div class="item">
                <div class="tit">{{ /*영업시간*/ $t("MMAIN-03-01-02-13") }}:</div>
                <div
                  class="dec"
                >{{ `${/*월*/ $t("MCOM-0000099")}~${/*금*/ $t("MCOM-0000103")}` }}, {{ $t(`영업시간_${siteCode}`) }}</div>
              </div>
              <div class="item">
                <div class="tit">{{ /*전화*/ $t("MMAIN-03-01-02-05") }}:</div>
                <div class="dec" v-if="operGroupCd == 'VN2'">{{ $t("지점별전화번호_oghni") }}</div>
                <div class="dec" v-else>{{ $t(`지점별전화번호_${siteCode}`) }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- Last Push Message -->
      <div
        class="push-message"
        v-if="initRBF0401P40.dataGrid != null && initRBF0401P40.dataGrid.length > 0"
      >
        <div class="cont-tit">
          <h6>{{ /*최종 푸시 메시지*/ $t("MMAIN-03-01-01-23") }}</h6>
        </div>
        <div class="box-normal" @click="goPage('1')">
          <i class="icon icon-alarm" />
          <span v-if="lang == 'KOR'">{{ initRBF0401P40.dataGrid[0].korTitle }}</span>
          <span v-else-if="lang == 'ENG'">{{ initRBF0401P40.dataGrid[0].engTitle }}</span>
          <span v-else v-html="$htmlDecode(initRBF0401P40.dataGrid[0].locTitle)"></span>
        </div>
      </div>
      <!-- 환율정보 -->
      <div class="exchange-info">
        <div class="cont-tit">
          <h6>{{ /*환율정보*/ $t("MMAIN-03-01-02-02") }}</h6>
        </div>
        <div class="box-normal">
          <div class="exchange-item" v-for="data in RBF0470140.dataGrid" :key="data.cnprtCncycd">
            <div class="nation" @click="goToDetail(data)">
              <i
                class="icon"
                :class="!_.isEmpty(getNationCode(data.cnprtCncycd)) ? `icon-nation-${getNationCode(data.cnprtCncycd)}` : ''"
              />
              <span class="name">{{ data.cnprtCncycd }}</span>
              <span
                class="amount"
                v-html="siteCode == $config.SITECODE_OGAUC ? $num(data.dealBaseExrt, 4, true) : $num(data.dealBaseExrt, null, true)"
              ></span>
            </div>
            <div :class="{ up: data.prdayCntstUpdwnRt > 0, down: data.prdayCntstUpdwnRt < 0 }">
              <em v-if="data.prdayCntstUpdwnRt > 0">↑</em>
              <em v-if="data.prdayCntstUpdwnRt < 0">↓</em>
              {{ $num(Math.abs(data.prdayCntstUpdwnRt)) }}
            </div>
          </div>
        </div>
        <div
          class="box-normal"
          v-if="siteCode != $config.SITECODE_OGAUC && siteCode != $config.SITECODE_OGMMR && siteCode != $config.SITECODE_OGIND && !isCorporationUser"
        >
          <div class="header">
            <div class="tit">{{ /*Mobile OTP ＆ 간편 로그인 서비스*/ $t("MMAIN-03-01-02-07") }}</div>
            <div class="new"></div>
          </div>
          <div class="content">
            <div class="item exchange-info-text">
              {{ /*휴대폰 인증으로 간편하게 사용할 수 있는 인증 수단 추가*/ $t("MMAIN-03-01-02-08") }}!
              <br />
              {{ /*KB 글로벌 뱅킹 서비스가 mOTP와 간편 로그인을 지원합니다*/ $t("MMAIN-03-01-02-09") }}
            </div>
            <button class="btn sm inline" @click="goPage('2')">{{ /*정보*/ $t("MMAIN-03-01-01-24") }}</button>
          </div>
        </div>
      </div>
      <div class="btn-area">
        <button class="btn icon-round" @click="pageData = 1">
          <i class="icon icon-undo" />
        </button>
      </div>
    </article>
  </div>
</template>

<script>
import { calendarRangeDateSet } from "@/mixins/basicComponent";
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";
import AppBar from "@/components/layout/AppBar";
import { RBF0401P40 } from "@/mixins/main";
export default {
  props: ["page", "isInit"],
  mixins: [calendarRangeDateSet, RBF0401P40],
  components: { AppBar },
  computed: {
    ...mapFields(["siteCode", "operGroupCd", "lang"]),
    ...mapFields("common/main", ["RBF0470140", "initRBF0401P40", "isCustNtcInq"]),
    ...mapFields("foreignExchange", ["RBF0470140Detail", "cnprtCncycd"]),
    ...mapGetters(["isLogin", "isCorporationUser"]),
    pageData: {
      get() {
        if (this.page == 2) {
          this.apiCall();
        }
        return this.page;
      },
      set(value) {
        this.$emit("update:page", value);
      },
    },
    isInitData: {
      get() {
        return this.isInit;
      },
      set(value) {
        this.$emit("update:isInit", value);
      },
    },
  },
  watch: {
    siteCode: {
      handler() {
        // this.ACT_setExrtRate();
        this.isInitData = false;
      },
    },
  },
  methods: {
    ...mapActions("common/main", ["ACT_setExrtRate"]),
    apiCall() {
      if (!this.isInitData) {
        this.ACT_setExrtRate();
        this.isInitData = true;
      }
    },
    getNationCode(cncycd) {
      let natCode = "";

      switch (cncycd) {
        case "KRW":
          natCode = "kr";
          break;
        case "JPY":
          natCode = "jp";
          break;
        case "EUR":
          natCode = "eu";
          break;
        case "NZD":
          natCode = "nz";
          break;
        case "USD":
          natCode = "us";
          break;
        case "AUD":
          natCode = "au";
          break;
        case "KHR":
          natCode = "cam";
          break;
        case "CHF":
          natCode = "chf";
          break;
        case "SGD":
          natCode = "sgd";
          break;
        case "GBP":
          natCode = "gbp";
          break;
        case "THB":
          natCode = "thb";
          break;
      }

      return natCode;
    },
    goToNoticeService() {
      this.$router.push({ name: "noticeService" });
    },
    goPage(data) {
      let pageName;

      if (data == "1") {
        //알림서비스
        pageName = "noticeService";
      } else if (data == "2") {
        //mOTP 이용가이드
        pageName = "userGuideMotp";
      }

      this.$emit("click", pageName);
    },
    goToDetail(item) {
      this.RBF0470140Detail = item;
      this.cnprtCncycd = item.cnprtCncycd;
      this.$router.push({ name: "foreignExchangeDtl" });
    },
  },
};
</script>
